import { service } from '@ember/service';

import type { PopupData, Service } from 'webapp-types';
import { BatchSelectActionType, ModelName } from 'webapp/enums/enums';

import ReportsSchedulesPopupSendLaterComponent from 'webapp/components/reports/schedules/popup-send-later';

import ReportSchedule from 'webapp/models-custom/report-schedule';
import type ReportScheduleRecord from 'webapp/models/report-schedule';

import ModelManagerForStoreService from 'webapp/services/model-manager/for-store';

export default class ModelManagerReportSchedulesService extends ModelManagerForStoreService<
	ReportScheduleRecord,
	ReportSchedule
> {
	@service('popup') declare popupService: Service.Popup;
	@service('request') declare requestService: Service.Request;
	@service('store') declare storeService: Service.Store;

	get unsentSavedRecords(): ReportScheduleRecord[] {
		return this.savedRecords.filter((item) => !item.isSent);
	}

	// approveSchedule(schedule: ReportSchedule): Promise<void> {
	// 	return this.requestService.api('POST', `/report-schedules/approve/${schedule.id}`).then((reply) => {
	// 		if (reply) {
	// 			this.storeService.pushPayload(reply);
	// 		}
	// 	});
	// }

	// unapproveSchedule(schedule: ReportSchedule): Promise<void> {
	// 	return this.requestService.api('DELETE', `/report-schedules/approve/${schedule.id}`).then((reply) => {
	// 		if (reply) {
	// 			this.storeService.pushPayload(reply);
	// 		}
	// 	});
	// }

	// skipSchedule(schedule: ReportSchedule): Promise<void> {
	// 	return this.requestService.api('POST', `/report-schedules/skip/${schedule.id}`).then((reply) => {
	// 		if (reply) {
	// 			this.storeService.pushPayload(reply);
	// 		}
	// 	});
	// }

	// unskipSchedule(schedule: ReportSchedule): Promise<void> {
	// 	return this.requestService.api('DELETE', `/report-schedules/skip/${schedule.id}`).then((reply) => {
	// 		if (reply) {
	// 			this.storeService.pushPayload(reply);
	// 		}
	// 	});
	// }

	openSendLaterPopup(props: PopupData.ReportSchedule.SendLater): void {
		this.popupService
			.createModal(ReportsSchedulesPopupSendLaterComponent, {
				popupClass: 'popup-type-report-schedule-send-later',
			})
			.open(props);
	}

	// ------ Batch actions ------

	override batchDelete(items: ReportSchedule[]): Promise<void> {
		return new Promise((resolve, reject) => {
			const affirmativeFunc = () => {
				const objectIds = items.map((item) => item.reportScheduleSettingId);
				this.batchAction(BatchSelectActionType.DELETE, objectIds)
					.then(resolve)
					.catch(reject);
			};

			this.popupService.openConfirmPopup({
				onConfirm: affirmativeFunc,
				title: `Are you sure you want to delete the (${items.length}) ${this.objectText}s?`,
				text: '<strong>This cannot be undone.</strong>',
				confirmAction: 'Delete',
				cancelAction: 'Cancel',
			});
		});
	}

	// ------ For-store ------

	modelName = ModelName.REPORT_SCHEDULE;

	createModel(model: ReportScheduleRecord): ReportSchedule {
		return new ReportSchedule({ model });
	}
}

declare module '@ember/service' {
	interface Registry {
		'model-manager/report-schedules': ModelManagerReportSchedulesService;
	}
}
